import { Grid } from '@mui/material'
import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from './Header'

const Layout = () => {
  return (
    <Grid
      container
      direction='column'
      justifyContent='center'
      alignItems='stretch'
      minHeight='100vh'
    >
      <Grid item>
        <Header />
      </Grid>
      <Grid item xs>
        <Outlet />
      </Grid>
    </Grid>
  )
}

export default Layout
